module.exports = __webpack_public_path__ + "img/COMBO RAINBOW RED.90211b3.svg";